import { t } from "i18next";
import { OrganizationRoleType } from "../../../../autogen/bff-api";
import { UserRole } from "./types";

export const entraOrganizationRoles: OrganizationRoleType[] = [
  OrganizationRoleType.Admin,
  OrganizationRoleType.SourcingCreator,
  OrganizationRoleType.SourcingViewer,
  OrganizationRoleType.ContractCreator,
  OrganizationRoleType.ContractViewer,
  OrganizationRoleType.ProjectCreator,
  OrganizationRoleType.ProjectViewer,
];

// Mirrors departmentAssignableRoles (bff/domain/.../DepartmentRoleAdministration.kt), which the API enforces.
export const entraDepartmentRoles: OrganizationRoleType[] = [
  OrganizationRoleType.Admin,
  OrganizationRoleType.SourcingCreator,
  OrganizationRoleType.SourcingViewer,
  OrganizationRoleType.ProjectCreator,
  OrganizationRoleType.ProjectViewer,
  OrganizationRoleType.ContractCreator,
  OrganizationRoleType.ContractViewer,
];

export const useSelectableRoles = (): UserRole[] => {
  return [
    {
      value: OrganizationRoleType.Admin,
      label: t("Admin"),
    },
    {
      value: OrganizationRoleType.SourcingCreator,
      label: t("Sourcing Creator"),
    },
    {
      value: OrganizationRoleType.SourcingViewer,
      label: t("Sourcing Viewer"),
    },
    {
      value: OrganizationRoleType.ContractCreator,
      label: t("Contract Creator"),
    },
    {
      value: OrganizationRoleType.ContractViewer,
      label: t("Contract Viewer"),
    },
    {
      value: OrganizationRoleType.ProjectCreator,
      label: t("Project Creator"),
    },
    {
      value: OrganizationRoleType.ProjectViewer,
      label: t("Project Viewer"),
    },
  ];
};
